<ng-container
  *ngTemplateOutlet="
    editing() ? defaultTpl : previewTpl ? previewTpl : defaultTpl;
    context: controlContext
  "
/>

<ng-template #defaultTpl>
  <div layout-horizontal>
    @if (editing()) {
      <div class="actions actions--primary">
        <ng-content />
      </div>
    }
    <div layout-full-width>
      <div class="field__container">
        @if (!multiline()) {
          @if (editPhoneNumber()) {
            <rt-phone-input
              [formControl]="parent"
              [countryCode]="countryCode()"
              [placeholder]="placeholder()"
              layout-full-width
            />
          } @else {
            <rt-input
              variant="rounded"
              [formControl]="parent"
              [autoFocus]="autofocus()"
              [placeholder]="placeholder()"
              (blur)="blur.emit(parent)"
            />
          }
        }
        @if (multiline()) {
          <rt-textarea
            [formControl]="parent"
            [autoFocus]="autofocus()"
            [placeholder]="placeholder()"
            [width]="'100%'"
            [autoHeight]="true"
            [defaultHeight]="40"
            [rows]="1"
            (blur)="blur.emit(parent)"
            variant="rounded"
          />
        }
        @if (editing()) {
          <div class="actions actions--secondary">
            <rt-icon-button
              variant="plain"
              (click)="remove.emit()"
              iconName="close"
              shape="square"
              size="small"
            />
          </div>
        }
      </div>
      @if (parent.invalid && editPhoneNumber()) {
        <div class="error-message" margin-top-small-xx>
          {{
            (parent.errors?.maxlength
              ? 'app.common.errors.phone.length'
              : 'app.common.errors.phone.invalid'
            ) | translate
          }}
        </div>
      }
    </div>
  </div>
</ng-template>
